import { combineReducers } from "@reduxjs/toolkit";
import invoice from "./invoice";
import payment from "./payment";

export default combineReducers({ invoice, payment });
